import React from 'react'
import SideLogo from '../../Images/TopbarImg/Logo.png'
import Aos from 'aos'

const Objectives = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    })

    return (
        <>
            <div className='main'>
                <div className='left-fixed'></div>
                <div className='aboutus-body'>
                    <div className='aboutus-left' data-aos='fade-right'>
                        <img src={SideLogo} alt='Kanaklaxmi-Logo' />
                    </div>
                    <div className='aboutus-right' data-aos='fade-right'>
                        <div className='aboutus-body-1'>
                            <div className='aboutus-body-title'>
                                <h1>हाम्रो उद्देश्य</h1>
                            </div>
                            <div className='aboutus-body-content'>
                                <p>
                                    <ul>
                                        <li>संस्थाद्वारा सदस्यहरूलाई उत्कृष्ट सेवा प्रदान गरी जीवनस्तर उकास्ने ।</li>
                                        <li>संस्थालाई सुशासन तथा व्यवसायिक ढङ्गले सञ्चालन गरी प्रतिश्पर्धी बनाउने ।</li>
                                        <li>संस्थाको संस्थागत अवस्था तथा मानव स्रोतको विकास गरी क्षमतावान बनाउने ।</li>
                                        <li>संस्थालाई वित्तीय रूपमा सुरक्षित तथा स्वस्थ्य राखि दिगो बनाउने । </li>
                                    </ul>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default Objectives